/* eslint-disable */
import PropTypes from 'prop-types';

const AccountDetailsPropTypes = {
  /**
   * The JSS classes to use
   */
  isCustom: PropTypes.bool,

  /**
   * The JSS classes to use
   */
  onChange: PropTypes.func,
};

export default AccountDetailsPropTypes;
